import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractHttpService } from './http-abstract.service';
import { AuthService } from './auth.service';
import { ReportResponseDto, ResultListDto } from "./dto";

@Injectable({
  providedIn: 'root'
})
export class HttpReportsService extends AbstractHttpService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super(httpClient, '/api/reports', authService);
  }

  getAllReports(startAt: Date, endAt: Date): Observable<ResultListDto<ReportResponseDto>> {
    const path = `/all?startAt=${encodeURIComponent(startAt.toISOString())}&endAt=${encodeURIComponent(endAt.toISOString())}`;
    return super.doGet<any>(true, path);
  }
}
